import store from '@/store';
import {
  getModule,
  Module,
  VuexModule,
  Mutation,
  Action
} from 'vuex-module-decorators';
import { ConditionObject, ValidateObject } from '@/Model/model';
import APP_CONST from '@/constants/AppConst';

@Module({
  namespaced: true,
  name: 'passwordStore',
  store,
  dynamic: true
})
class PasswordModule extends VuexModule {

  public oldPassword: string = '';
  public password: string = '';
  public confirmPassword: string = '';
  public isPasswordValid: boolean = false;
  public rules: Array<ConditionObject> = [
    { message: APP_CONST.TEN_CHARACTER_MSG, regex: /^(?=.*[A-Za-z0-9_@])(?=.*[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]).{10,15}$/ },
    { message: APP_CONST.CAPITAL_MSG, regex: /[A-Z]+/ },
    { message: APP_CONST.LOWERCASE_MSG, regex: /[a-z]+/ },
    { message: APP_CONST.SPECIAL_CHAR_MSG, regex: /[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/ },
    { message: APP_CONST.ONE_NUMBER, regex: /[0-9]+/ }
  ];

  get getOldPassword(): string {
    return this.oldPassword;
  }

  get getRules(): Array<ConditionObject> {
    return this.rules;
  }
  get getPassword(): string {
    return this.password;
  }
  get getConfirmPassword(): string {
    return this.confirmPassword;
  }

  @Mutation
  public setOldPasswordMutate(payload: string): void {
    this.oldPassword = payload;
  }
  @Action({ commit: 'setOldPasswordMutate' })
  public setOldPassword(payload: string): string {
    return payload;
  }

  @Mutation
  public setPasswordMutate(payload: string): void {
    this.password = payload;
  }
  @Action({ commit: 'setPasswordMutate' })
  public setPassword(payload: string): string {
    return payload;
  }

  @Mutation
  public setConfirmPassMutate(payload: string): void {
    this.confirmPassword = payload;
  }

  @Action({ commit: 'setConfirmPassMutate' })
  public setConfirmPassword(payload: string): string {
    return payload;
  }

  get passwordValidityCheck(): boolean {
    return this.isPasswordValid;
  }

  @Mutation
  public mutatePasswordValid(payload: ValidateObject) {
    this.isPasswordValid = payload.valid;
  }
  @Action({ commit: 'mutatePasswordValid' })
  public setIsPasswordValid(obj: ValidateObject): ValidateObject {
    return obj;
  }
}

export default getModule(PasswordModule);
